import {InjectionToken} from '@angular/core'
import type {Request, Response} from 'express'

// in local development, you won't get the tokens because SSR is managed by vite
// test this in a deployed environment
export const REQUEST = new InjectionToken<Request>('REQUEST')
export const RESPONSE = new InjectionToken<Response>('RESPONSE')
